import React from 'react';
import { humanize, titleize } from 'underscore.string';
import ToolTip from 'components/v2/Tooltip';
import ExclamationIcon from 'components/v2/icons/ExclamationIcon';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';

function renderWarningIcon() {
  return <ExclamationIcon className="text-red-700 w-5 h-5" />;
}

function ChargeInfo({ chargeCode, chargeId }) {
  const { t } = useTranslation();
  return (
    (<div data-testid="div-54633db5" className="text-gray-200">
      {chargeCode && (
        <DescriptionListItem
          dataTestId="DescriptionListItem-b3cd5863"
          label={t('CHARGE_CODE')}
          darkMode>
          {humanize(t(sluggify(chargeCode)))}
        </DescriptionListItem>
      )}
      {chargeId && (
        <DescriptionListItem
          dataTestId="DescriptionListItem-1482b212"
          label={t('CHARGE_ID')}
          className="mt-2"
          darkMode>
          {humanize(t(sluggify(chargeId)))}
        </DescriptionListItem>
      )}
    </div>)
  );
}

export default function AdjustmentTitle({ lineItem, unapplied }) {
  const { _id, message, type, charge_code, charge_id } = lineItem;
  const { t } = useTranslation();
  const chargeCodeTooltipId = `charges-${_id}`;
  const unappliedTooltipId = `unapplied-${_id}`;
  const chargeTitle =
    type === 'customer_adjustment'
      ? message || type
      : t(sluggify(message || type));
  return (
    (<div
      data-testid="div-4025c77f"
      className="flex items-center space-x-1 flex-wrap min-w-0 w-48">
      <span data-testid="span-93b08d65" className="break-all">{chargeTitle}</span>
      {(charge_code || charge_id) && (
        <ToolTip dataTestId="ToolTip-48606f66" id={chargeCodeTooltipId}>
          <ChargeInfo chargeCode={charge_code} chargeId={charge_id} />
        </ToolTip>
      )}
      {unapplied && (
        <ToolTip
          dataTestId="ToolTip-aae84eb1"
          id={unappliedTooltipId}
          body={renderWarningIcon}>
          {t('NOT_APPLIED_TO_AN_EQUIPMENT')}
        </ToolTip>
      )}
    </div>)
  );
}
